import React, { useEffect, useState } from 'react';
import { Button, Dropdown, Form, Modal } from 'semantic-ui-react';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import * as actions from '../../redux/actions';
import * as selectors from '../../redux/selectors';
import { bindActionCreators } from 'redux';
import * as _ from 'lodash';

export const AddUserToRoleDialog = ({ currentUser, addUserRole, reloadUsers, roleOptions, loadUserRoles }) => {
  const [open, setOpen] = React.useState(false);
  const [role, setRole] = useState({ name: '' });

  const handleSubmit = role => {
    addUserRole(currentUser, role);
    reloadUsers();
    setOpen(false);
  };

  const handleClose = formik => {
    formik.resetForm();
    setOpen(false);
  };

  const handleOpen = formik => {
    loadUserRoles();
    formik.resetForm();
    setOpen(true);
  };

  useEffect(() => {
    if (!_.isEmpty(roleOptions)) {
      setRole({ name: roleOptions[0].value });
    }
  }, [roleOptions]);

  return (
    <Formik initialValues={role} enableReinitialize onSubmit={handleSubmit}>
      {formik => (
        <Modal
          onClose={() => handleClose(formik)}
          onOpen={() => handleOpen(formik)}
          open={open}
          trigger={<Button icon="plus" content="Add user to role" />}
        >
          <Modal.Header>Add user to role</Modal.Header>
          <Modal.Content>
            <Form widths="equal" onSubmit={formik.handleSubmit}>
              <Form.Field error={Boolean(formik.errors.name)}>
                <label htmlFor="name">Role</label>
                <Dropdown
                  fluid
                  search
                  selection
                  options={roleOptions || []}
                  id="name"
                  data-testid="name"
                  label="Role"
                  name="name"
                  value={formik.values.name}
                  onChange={(e, d) => formik.setFieldValue(d.name, d.value)}
                />
              </Form.Field>
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button color="black" onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button
              type="submit"
              content="Add user to role"
              loading={formik.isSubmitting}
              onClick={formik.handleSubmit}
              positive
            />
          </Modal.Actions>
        </Modal>
      )}
    </Formik>
  );
};

const mapStateToProps = state => ({
  currentUser: selectors.getCurrentAdminUser(state),
  roleOptions: state.admin.roleOptions,
});

const mapDispatchToProps = dispatch => ({
  addUserRole: bindActionCreators(actions.admin.addUserRole, dispatch),
  reloadUsers: bindActionCreators(actions.admin.getUsers, dispatch),
  loadUserRoles: bindActionCreators(actions.admin.getRoles, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddUserToRoleDialog);
